import { WorkspaceSwitcher } from "@/workspaces"

interface WorkspaceSidebarSelectorProps {
  className?: string
}

export function WorkspaceSidebarSelector({
  className,
}: WorkspaceSidebarSelectorProps) {
  return <WorkspaceSwitcher className={className} />
}
